import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_serverProtect",
  "use": "icon-icon_serverProtect-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_serverProtect\">\n    <path d=\"M2 0C0.895 0 0 0.895 0 2V18C0 19.105 0.895 20 2 20H10.0059C9.67486 19.406 9.41233 18.737 9.23633 18H2V14H9V12H2V8H14V9.48438L16 8.59961V2C16 0.895 15.105 0 14 0H2ZM2 2H14V6H2V2ZM15.5 11L11 13V16C11 19.915 14.22 21.743 15.5 22C16.78 21.743 20 19.915 20 16V13L15.5 11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol